import type { ReactNode } from 'react';

/**
 * Shared full-bleed background for survey pages. Background width matches the shell only
 * (no horizontal overflow / side-scroll).
 */
export default function SurveyBackgroundLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-[100dvh] w-full max-w-full flex-1 flex-col px-6 pb-12">
      <div
        className="pointer-events-none absolute inset-0 max-w-full bg-[url('/images/LD_BG.png')] bg-[length:100%_auto] bg-top bg-no-repeat"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/15 via-transparent to-black/25"
        aria-hidden
      />
      <div className="relative z-10 min-h-[100dvh] w-full max-w-full min-w-0 flex-1">{children}</div>
    </div>
  );
}
